/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const phoneCustomerSettingsBodyVersionExclusiveMin = 0;
export const phoneCustomerSettingsBodyVersionMax = 9007199254740991;

export const phoneCustomerSettingsBodyClientCodeMin = 4;
export const phoneCustomerSettingsBodyClientCodeMax = 4;

export const phoneCustomerSettingsBodyClientCodeRegExp = new RegExp('^[0-9]{4}$');
export const phoneCustomerSettingsBodyRecognizedCallerGreetingOneTwoTextMax = 400;

export const phoneCustomerSettingsBodyRecognizedCallerGreetingOneThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const PhoneCustomerSettingsBody = zod.object({
  version: zod
    .int()
    .gt(phoneCustomerSettingsBodyVersionExclusiveMin)
    .max(phoneCustomerSettingsBodyVersionMax),
  clientCode: zod
    .string()
    .min(phoneCustomerSettingsBodyClientCodeMin)
    .max(phoneCustomerSettingsBodyClientCodeMax)
    .regex(phoneCustomerSettingsBodyClientCodeRegExp),
  recognizedCallerGreeting: zod.union([
    zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod
          .string()
          .min(1)
          .max(phoneCustomerSettingsBodyRecognizedCallerGreetingOneTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod
          .uuid()
          .regex(phoneCustomerSettingsBodyRecognizedCallerGreetingOneThreeAssetIdRegExp),
      }),
    ]),
    zod.null(),
  ]),
});

export type PhoneCustomerSettingsBody = zod.input<typeof PhoneCustomerSettingsBody>;
export type PhoneCustomerSettingsBodyOutput = zod.output<typeof PhoneCustomerSettingsBody>;
